// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"84495634","252":"6c2600df","466":"4a05a7c2","488":"8437f958","497":"313df988","507":"3d73b9a5","576":"66b08ac6","780":"648dc9ed","846":"8621ffcc","996":"f16d5897"}[chunkId] + ".chunk.js";
};